import { Box, Typography } from "@mui/material";

export default function SocialButton({img,style,textStyle,onPress,title}){
    return (
        <Box onClick={onPress} sx={[{border:"2px solid #2626261A",borderRadius:"5px",cursor:"pointer",background:"#0BB2D00D",display:"flex",justifyContent:"center",alignItems:"center",height:"50px",width:"45%"},style]}>
            <img style={{height:"18px",objectFit:"contain"}} src={img}   />
            <Typography sx={[{fontSize:"12px",marginLeft:"3px",color:"#0DB1D4"},textStyle]}>{title}</Typography>
        </Box>
    )
}